import React from "react";

const Title = ({ title, des }) => {
  return (
    <div className="flex flex-col gap-4 font-titleFont mb-14">
      <h3 className="text-sm uppercase font-light text-designColor tracking-[0.2em] font-mono">
        {title}
      </h3>
      <h1 className="text-4xl md:text-5xl font-bold capitalize heading-gradient">
        {des}
      </h1>
    </div>
  );
};

export default Title;
